import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'angular2-notifications';
import { ApiService } from '../../../utils/services/api.service';
import { BankBinNumberInfoModalComponent } from './bank-bin-number-info-modal/bank-bin-number-info-modal.component';
import { DialogModalComponent } from '../../../shared/dialog-modal/dialog-modal.component';

@Component({
  selector: 'app-bank-bin-numbers',
  templateUrl: './bank-bin-numbers.component.html',
  styleUrls: ['./bank-bin-numbers.component.scss']
})
export class BankBinNumbersComponent implements OnInit {


  public binNumbers = [];
  public totalCount = 0;
  public urlSearchParams = new URLSearchParams();
  public filter = { bank: "", binNumber: "" };
  public filterForm: FormGroup;
  public filterSubscriptions: Subscription[] = [];

  constructor(
    private apiService: ApiService,
    private notifications: NotificationsService,
    private modalService: NgbModal) {

    this.filterForm = new FormGroup({
      "bank": new FormControl(null),
      "binNumber": new FormControl(null)
    });


    this.resetSearchParams();
    this.fetchBinNumbers();
    this.listenFilterEvents();

  }

  ngOnInit() {

  }
 

  onDeleteClicked(item) {
    let dialogRef = this.modalService.open(DialogModalComponent, { size: 'sm' });
    dialogRef.componentInstance.modalTitle = "Bu kaydı silmek istediğinize emin misiniz?"
    dialogRef.result.then(res => {
      if (res) {
        if (res.type == 'YES') {
          this.apiService.deleteBinNumber(item.id).subscribe(res => {
            this.notifications.success("Silme işlemi başarılı!");
          }, error => {
            this.notifications.error("Hata", "İşlem başarısız!");
          })
        }
      }
    });
  }
  onAddClicked() {
    let dialogRef = this.modalService.open(BankBinNumberInfoModalComponent, { size: 'sm' });
    dialogRef.result.then(result => {
          this.resetSearchParams();
          this.fetchBinNumbers();
    }, dismiss => {

    })
  }
  fetchBinNumbers() {
    this.apiService.getBankBinNumbers(this.urlSearchParams).subscribe((res) => {
      this.binNumbers = res.data.rows;
      this.totalCount = res.data.count;
    }, error => {
      this.binNumbers = [];
      this.totalCount = 0;
      if (error.status != 404) {
        this.notifications.error("Hata", "İşlem başarısız!");
      }
    });
  }
  changePage(event) {
    this.urlSearchParams = new URLSearchParams();
    this.urlSearchParams.set("offset", (event * 100).toString());
    this.urlSearchParams.set("limit", "100");
    this.urlSearchParams.set("sortBy", "bank");
    this.urlSearchParams.set("sortType", "asc");
    this.fetchBinNumbers();
  }
  listenFilterEvents() {

    let bankSub = this.filterForm.controls.bank.valueChanges.pipe(debounceTime(300),
      distinctUntilChanged()).subscribe(val => {
        this.filter.bank = val;
        this.runFilter();
      });

    let binSub = this.filterForm.controls.binNumber.valueChanges.pipe(debounceTime(300),
      distinctUntilChanged()).subscribe(val => {
        this.filter.binNumber = val;
        this.runFilter();
      });


    this.filterSubscriptions = [bankSub, binSub];
  }

  runFilter() {
    this.resetSearchParams();
    if (this.filter.bank) {
      this.urlSearchParams.set("bank_Sw", this.filter.bank,);
    }
    if (this.filter.binNumber) {
      this.urlSearchParams.set("binNumber_Sw", this.filter.binNumber);
    }

    this.fetchBinNumbers();
  }

  ngOnDestroy(): void {
    this.filterSubscriptions.forEach(sub => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }

  resetSearchParams() {
    this.urlSearchParams = new URLSearchParams();
    this.urlSearchParams.set("offset", "0");
    this.urlSearchParams.set("limit", "100");
    this.urlSearchParams.set("sortBy", "bank");
    this.urlSearchParams.set("sortType", "asc");
  }

  onRowClicked(item) {
    let modalRef = this.modalService.open(BankBinNumberInfoModalComponent, { size: "sm" });
    modalRef.componentInstance.selectedEntity = { ...item };
    modalRef.result.then(res => {
      if (res) {
        this.resetSearchParams();
        this.fetchBinNumbers();
      }
    }, dissmiss => {

    })
  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/bank-bin-numbers/bank-bin-numbers.component.ts